import { defaultHttpClient } from 'shared/src/api/httpClient';
import type { Address, AddressUpsertParams } from './types';

type PutAddressParams = AddressUpsertParams & { sno: number };
type PutAddressResponse = {
  address: Address;
};

/**
 * - 배송지 수정
 * - `PUT /members/me/addresses/{sno}/`
 */
export const putAddress = ({ sno, ...body }: PutAddressParams) => {
  return defaultHttpClient
    .request<PutAddressResponse>({
      method: 'PUT',
      url: `/api/v2/members/me/addresses/${sno}/`,
      data: body,
    })
    .then(r => r.data);
};
